// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__85QLZ","right":"styles_right__3Mnei"};